import React, { useState, useEffect } from "react";
import { Validation } from '../../utils/validation';
import './Modal.css';

const ShareBonusModal = ({ isShow, setFormData, formData, onFinalSubmit, onClose }) => {
	const [errors, setErrors] = useState({});

	useEffect(() => {
		if (isShow) {
			setErrors({});
		}
	}, [isShow]);

	const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Stop page refresh
        
        // let validationErrors = Validation(formData, ['email']);
        
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        // setErrors({});
        onFinalSubmit(); // Trigger final API submission in parent
    };

    if (!isShow) return null;

    return (
    	<React.Fragment>
	      {isShow && (
	        <div className="motor-modal-overlay">
	          <div className="motor-modal-content">
	            <form className="motor-error-report-form d-flex flex-column gap-3" onSubmit={handleSubmit}>
	              <div className="form-group">
	                <label htmlFor="email">Email</label>
	                <input
	                  type="text"
	                  className="form-control"
	                  id="email"
	                  name="email"
	                  value={formData.email || ''}
	                  onChange={handleChange}
	                />
	                {errors.email && (
	                  <div className="text-danger">{errors.email}</div>
	                )}
	              </div>
	              <div className="d-flex w-100 justify-content-evenly gap-4">
	                <button
	                  type="button"
	                  className="btn btn-secondary w-50 m-0 rounded"
	                  onClick={onClose} // parent will toggle modal
	                >
	                  Close
	                </button>
	                <button
	                  type="submit"
	                  className="submit-button w-50 m-0 rounded submit-error-report"
	                >
	                  Share
	                </button>
	              </div>
	            </form>
	          </div>
	        </div>
	      )}
	    </React.Fragment>
	);
};

export default ShareBonusModal;